import React, { useState } from "react";
import api, { getApiErrorMessage } from "../../core/api";
import Icon from "../../components/Icon/Icon";
import s from "./Login.module.scss";

export default function ForgotPasswordForm({ onBack }) {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) {
      setError(getApiErrorMessage(err, "Invio non riuscito. Riprova."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={s.formBox}>
      <span className={s.mailIcon}>
        <Icon name={sent ? "check" : "lock"} size={32} strokeWidth={1.6} />
      </span>
      <h2 className={s.welcome}>{sent ? "Controlla la posta" : "Password dimenticata"}</h2>
      <p className={s.subtitle}>
        {sent
          ? "Se l'indirizzo è registrato, ti abbiamo mandato un link per reimpostare la password. Vale un'ora."
          : "Scrivi la tua email: ti mandiamo un link per scegliere una nuova password."}
      </p>
      {!sent && (
        <form className={s.form} onSubmit={submit}>
          <div className={s.inputWrap}>
            <Icon name="mail" size={18} />
            <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} autoFocus />
          </div>
          {error && <div className="pr-error">{error}</div>}
          <button type="submit" className={s.mainButton} disabled={loading || !email.trim()}>
            {loading ? "Invio..." : "Invia il link"}
          </button>
        </form>
      )}
      <button type="button" className={s.back} onClick={onBack}>
        <Icon name="arrowLeft" size={16} /> Torna all'accesso
      </button>
    </div>
  );
}
